// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AH7-w","right":"styles_right__3R5Q3"};